import React, { useRef, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";
import { Upload, Loader2, X } from "lucide-react";

// Uploads an image to object storage and returns a relative served URL via onChange.
export default function ImageUpload({ value, onChange, testid = "image-upload", label = "Photo", camera = true }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await axios.post(`${API}/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } catch {
      alert("Upload failed. Please try a smaller image.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          data-testid={testid}
          className="flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
        >
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}
          {busy ? "Uploading…" : `Upload ${label}`}
        </button>
        {value && (
          <button type="button" onClick={() => onChange("")} className="text-slate-400 hover:text-red-500" data-testid={`${testid}-clear`}>
            <X size={18} />
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" capture={camera ? "environment" : undefined} onChange={pick} className="hidden" />
      {value && <img src={value} alt="preview" className="mt-2 h-28 w-full rounded-lg object-cover" />}
    </div>
  );
}
